import 'babel-polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './vuex/store'
import vuetify from './plugins/vuetify'
import http from './http'
import VueNotification from '@kugatsu/vuenotification'
import Vue2Filters from 'vue2-filters'
import VueTheMask from 'vue-the-mask'
import VueAnalytics from 'vue-analytics'
import VCurrencyField from 'v-currency-field'
import { VTextField } from 'vuetify/lib'
import { esconderPalavras } from './helpers/utils.js'
import { VueMaskDirective } from 'v-mask'
import VueSanitize from "vue-sanitize";
var VueCookie = require('vue-cookie');
// Tell Vue to use the plugin
Vue.use(VueCookie);
Vue.filter('esconderValores', esconderPalavras);
Vue.prototype.$http = http
Vue.use(VueNotification, { timer: 20 })
Vue.use(require('vue-moment'))
Vue.use(Vue2Filters)
Vue.use(VueSanitize);
Vue.use(VueTheMask)
Vue.directive('mascara', VueMaskDirective);

Vue.directive('restrict', {
  bind(el, binding) {
    el.addEventListener('keydown', (e) => {
      // delete, backpsace, tab, escape, enter,
      let special = [46, 8, 9, 27, 13]
      if (binding.modifiers['decimal']) {
        // decimal(numpad), period
        special.push(110, 190)
      }
      // special from above
      if (special.indexOf(e.keyCode) !== -1 ||
        // Ctrl+A
        (e.keyCode === 65 && e.ctrlKey === true) ||
        // Ctrl+C
        (e.keyCode === 67 && e.ctrlKey === true) ||
        // Ctrl+X
        (e.keyCode === 88 && e.ctrlKey === true) ||
        // home, end, left, right
        (e.keyCode >= 35 && e.keyCode <= 39)) {
        return // allow
      }
      if ((binding.modifiers['alpha']) &&
        // a-z/A-Z
        (e.keyCode >= 65 && e.keyCode <= 90)) {
        return // allow
      }
      if ((binding.modifiers['number']) &&
        // number keys without shift
        ((!e.shiftKey && (e.keyCode >= 48 && e.keyCode <= 57)) ||
          // numpad number keys
          (e.keyCode >= 96 && e.keyCode <= 105))) {
        return // allow
      }
      // otherwise stop the keystroke
      e.preventDefault() // prevent
    }) // end addEventListener
  }
}) // end bind


Vue.use(VueAnalytics, {
  id: 'UA-72959774-11',
  router
})
Vue.component('v-text-field', VTextField)

Vue.use(VCurrencyField, {
  locale: 'pt-BR',
  decimalLength: 2,
  autoDecimalMode: true,
  min: null,
  max: null,
  defaultValue: 0,
  valueAsInteger: false,
  allowNegative: false
})

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
  created() {

  }
}).$mount('#app')
